import { React } from "react";
import "./SearchBox.css";
import { SeachIconConvg, SearchIconLeft } from "../../../../IconComponents/index.js";
import { useTranslation } from "react-i18next";

const SearchBox = ({ searchValue, onSearchHandler, noBorder }) => {
  const { t } = useTranslation();
  
  return (
    <form className="search-form" style={{ display: "flex", alignItems: "center" }}>
      {noBorder && (
        <button 
          className="search-button" 
          type="button"
          style={{ 
            height: "45px", 
            width: "45px", 
            background: "transparent",
            border: "1px solid #ccc",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <SeachIconConvg width="1.3em" height="1.3em" />
        </button>
      )}
      
      <input
        type="text"
        placeholder={t("searchPlaceholder")}
        value={searchValue}
        onChange={(e) => onSearchHandler(e.target.value)}
        style={{
          ...(noBorder && {
            border: "1px solid #ccc",
            width: "501px",
            height: "46px"
          }),
          border: "1px solid #ccc",
          padding: "8px",
          outline: "none",
          transition: "width 0.3s ease-in-out",
        }}
      />
      
      {!noBorder && (
        <button 
          disabled={true} 
          type="button"
          style={{
            background: "transparent",
            border: "1px solid #ccc",
            height: "28px",
            width: "45px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <SearchIconLeft width="1.3em" height="1.3em" />
        </button>
      )}
    </form>
  );
};

export default SearchBox;